import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import { TextField, Popover, Box, Avatar, InputAdornment, Divider, ListItemText, MenuItem } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import CheckIcon from '@material-ui/icons/Check';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
import moment from "moment";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ls from "local-storage";
import { MdAddBox } from 'react-icons/md';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PageLoader from '../../Layouts/PageLoader';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';

const inivalue = {
    selectedDate: "",
    startTime: "",
    endTime: ""
}

const iniDoc = {
    id: "",
    firstName: ""
};

const AddTime = (props) => {
    const classes = props;
    const [addValues, setAddValues] = useState(inivalue);
    const [formErrors, setFormErrors] = useState({});
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [doc, setDoc] = useState(iniDoc);
    const [notificationDetails, setNotificationDetails] = useState([]);
    const [userRole, setUserRole] = useState(ls("roles"));
    const [dataFetched, setDataFetched] = useState(false);
    const [hoveredButton, setHoveredButton] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);
    const [userPopoverAnchor, setUserPopoverAnchor] = useState(null);
    const [userSearchQuery, setUserSearchQuery] = useState("");
    const [pageLoading, setPageLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    const getInitials = (name) => {
        if (!name) return "";
        const parts = name.split(" ");
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.slice(0, 2).toUpperCase();
    };

    const handleOpenUserPopover = (event) => {
        setUserPopoverAnchor(event.currentTarget);
        setUserSearchQuery("");
    };

    const handleCloseUserPopover = () => {
        setUserPopoverAnchor(null);
        setUserSearchQuery("");
    };

    const handleSelectUser = async (userName) => {
        setDoc(prevDoc => ({ ...prevDoc, firstName: userName }));

        const selectedUser = filteredUsers.find(user => user.firstName === userName);
        if (selectedUser) {
            setDoc(prevDoc => ({
                ...prevDoc,
                id: selectedUser.id,
                firstName: userName
            }));
            if (addValues.selectedDate) {
                await fetchNotifications(selectedUser.id, addValues.selectedDate);
            }
        } else {
            setDoc(prevDoc => ({ ...prevDoc, id: "", firstName: "" }));
            setNotificationDetails([]);
        }
        handleCloseUserPopover();
    };

    const handleMouseEnter = (index) => {
        setHoveredButton(index);
    };

    const handleMouseLeave = () => {
        setHoveredButton(null);
    };

    const handleClickOpen = (detail) => {
        setSelectedDetail(detail);
        setAddValues({
            ...addValues,
            startTime: convertTo24HourFormat(detail.in_time),
            endTime: convertTo24HourFormat(detail.out_time)
        });
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
        userData();
    }, []);

    const userData = async () => {
        setPageLoading(true);
        try {
            // First check cache for faster loading
            const cachedUsers = ls.get('cached_all_users');
            if (cachedUsers && Array.isArray(cachedUsers)) {
                const loggedInUsers = cachedUsers.filter(user => user.user_logged === 1).map(u => ({
                    ...u,
                    name: u.firstName,
                    photo: u.photo || "",
                    initials: getInitials(u.firstName)
                }));
                setFilteredUsers(loggedInUsers);
            }

            // Set role from local storage
            setUserRole(ls("roles"));

            let users = await AuthApi.getData();
            if (users && users.status === true) {
                const loggedInUsers = users.data.filter(user => user.user_logged === 1).map(u => ({
                    ...u,
                    name: u.firstName,
                    photo: u.photo || "",
                    initials: getInitials(u.firstName)
                }));
                setFilteredUsers(loggedInUsers);
                
                // Update cache
                if (users.data.length > 0) {
                    ls.set('cached_all_users', users.data);
                }
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setPageLoading(false);
        }
    };



    const handleChange = async (e) => {
        const { name, value } = e.target;
        setAddValues({ ...addValues, [name]: value });
        if (name === "selectedDate" && (doc.id || userRole === 'Employee')) {
            await fetchNotifications(doc.id || props.authUser.id, value);
        }
    };

    const fetchNotifications = async (userId, selectedDate) => {
        setTableLoading(true);
        try {
            const date = moment(selectedDate, 'YYYY-MM-DD');
            const year = date.year();
            const month = date.month() + 1;
            const day = date.date();

            let data;
            if (userRole === 'Super Admin') {
                data = await AuthApi.ShowMissingTimeEntriesById(userId, day, month, year);
            } else if (userRole === 'Employee') {
                data = await AuthApi.ShowMissingTimeEntriesById(ls("user").id, day, month, year);
            }

            if (data && Array.isArray(data.data)) {
                setNotificationDetails(data.data);
            } else {
                console.error("Error: data.data is not iterable or no data returned");
                setNotificationDetails([]);
            }
            setDataFetched(true);
        } finally {
            setTableLoading(false);
        }
    };

    const validate = (values) => {
        let errors = {};
        const dobRegx = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

        if (userRole === 'Super Admin' && !doc.firstName) {
            errors.firstName = "Please select a user";
        }

        if (!values.selectedDate) {
            errors.selectedDate = "Cannot be blank";
        } else if (!dobRegx.test(values.selectedDate)) {
            errors.selectedDate = "Invalid dob format";
        }

        if (!values.startTime) {
            errors.startTime = "Cannot be blank";
        }

        if (!values.endTime) {
            errors.endTime = "Cannot be blank";
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitLoading) {
            return;
        }
        const errors = validate(addValues);
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        await addTimeData();
    };

    const addTimeData = async () => {
        setSubmitLoading(true);
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode()
        });
        try {
            const payload = {
                ...addValues,
                id: userRole === 'Super Admin' ? doc.id : ls("user").id
            };
            let create1 = await AuthApi.addTime(payload);
            swal.close();
            if (create1 && create1.status === true) {
                swal("Success", "Time entry added successfully", "success").then(() => {
                    props.history.push('/time-entries');
                });
            } else {
                swal("Error", create1 && create1.message ? create1.message : "Failed to add time entry", "error");
            }
        } catch (error) {
            swal.close();
            swal({
                title: "OOPS!",
                icon: "error",
                text: "Something went wrong, Please try later!"
            });
            console.error("Error updating time:", error);
        } finally {
            setSubmitLoading(false);
        }
    };

    const convertTo24HourFormat = (time) => {
        const [timePart, modifier] = time.split(' ');
        let [hours, minutes] = timePart.split(':');

        if (hours === '12') {
            hours = '00';
        }

        if (modifier === 'PM') {
            hours = parseInt(hours, 10) + 12;
        }

        return `${hours}:${minutes}`;
    };

    const handleAddTime = () => {
        handleSubmit({ preventDefault: () => { } });
    };

    const handlePopupChange = (e) => {
        const { name, value } = e.target;
        setAddValues({ ...addValues, [name]: value });
    };

    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + (d.getDate()),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    var ds = [year, month, day].join('-');

    if (pageLoading) {
        return (
            <div>
                <AuthCheckComponent authToken={props.authToken} />
                <Header {...props} authUser={props.authUser} component={<PageLoader />} />
                <Footer />
            </div>
        );
    }

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <Card className={classes.root} style={{ marginBottom: '3%' }}>
                            <CardContent>
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="User Check"
                                    primaryPageLink="/time-entries"
                                    isSecondaryPage={true}
                                    secondaryPageName="Add Time Entry" />
                            </CardContent>
                        </Card>
                        <Grid container className={classes.root} spacing={2}>
                            <Grid item xs={12}>
                                <Card className={classes.root}>
                                    <CardContent>
                                        <Typography variant="h2">Add Time-Entry</Typography>
                                        <form className={classes.form} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={5}>
                                                {userRole === 'Super Admin' && (
                                                    <Grid item xs={6}>
                                                        <div style={{ position: 'relative' }}>
                                                            {/* Floating Label sitting on the border */}
                                                            <label style={{
                                                                position: 'absolute',
                                                                left: '12px',
                                                                top: '-10px',
                                                                backgroundColor: document.documentElement.getAttribute('data-theme') === 'dark' ? '#1e1e1e' : 'white',
                                                                padding: '0 5px',
                                                                fontSize: '0.75rem',
                                                                color: '#1b6e95',
                                                                zIndex: 1,
                                                                fontWeight: 500,
                                                                pointerEvents: 'none'
                                                            }}>
                                                                User First Name
                                                            </label>

                                                            <Box
                                                                onClick={(e) => handleOpenUserPopover(e)}
                                                                style={{
                                                                    height: '56px',
                                                                    border: formErrors.firstName ? '2px solid #f44336' : '1px solid #c4c4c4',
                                                                    borderRadius: '4px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'space-between',
                                                                    padding: '0 14px',
                                                                    cursor: 'pointer',
                                                                    backgroundColor: 'transparent'
                                                                }}
                                                            >
                                                                <Box display="flex" alignItems="center">
                                                                    {doc.firstName ? (
                                                                        <>
                                                                            {(() => {
                                                                                const u = filteredUsers.find(user => user.firstName === doc.firstName);
                                                                                return u ? (
                                                                                    <Avatar
                                                                                        src={u.photo || ""}
                                                                                        style={{ width: 24, height: 24, marginRight: 10, fontSize: '0.8rem' }}
                                                                                    >
                                                                                        {u.initials}
                                                                                    </Avatar>
                                                                                ) : null;
                                                                            })()}
                                                                            <Typography variant="body1">{doc.firstName}</Typography>
                                                                        </>
                                                                    ) : (
                                                                        <Typography variant="body1" style={{ color: '#666' }}>None</Typography>
                                                                    )}
                                                                </Box>
                                                                <ExpandMoreIcon style={{ color: '#666' }} />
                                                            </Box>

                                                            {formErrors.firstName && (
                                                                <span className="error" style={{ fontSize: '0.75rem', color: '#f44336', marginLeft: '14px' }}>{formErrors.firstName}</span>
                                                            )}

                                                            <Popover
                                                                open={Boolean(userPopoverAnchor)}
                                                                anchorEl={userPopoverAnchor}
                                                                onClose={handleCloseUserPopover}
                                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                                                PaperProps={{
                                                                    style: { width: 300, marginTop: 5, borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }
                                                                }}
                                                            >
                                                                <Box p={1.5}>
                                                                    <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8, color: '#1B6E95' }}>Select User</Typography>
                                                                    <TextField
                                                                        fullWidth
                                                                        size="small"
                                                                        placeholder="Search users..."
                                                                        variant="outlined"
                                                                        value={userSearchQuery}
                                                                        onChange={(e) => setUserSearchQuery(e.target.value)}
                                                                        InputProps={{
                                                                            startAdornment: (
                                                                                <InputAdornment position="start">
                                                                                    <SearchIcon fontSize="small" />
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                </Box>
                                                                <Divider />
                                                                <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                                                                    <MenuItem
                                                                        onClick={() => handleSelectUser("")}
                                                                        style={{ padding: '8px 16px' }}
                                                                    >
                                                                        <ListItemText primary="None" />
                                                                        {!doc.firstName && <CheckIcon style={{ color: '#16a34a', fontSize: '1.2rem' }} />}
                                                                    </MenuItem>
                                                                    {filteredUsers.filter(u => u.firstName.toLowerCase().includes(userSearchQuery.toLowerCase())).map((user, index) => (
                                                                        <MenuItem
                                                                            key={index}
                                                                            onClick={() => handleSelectUser(user.firstName)}
                                                                            style={{ padding: '8px 16px' }}
                                                                        >
                                                                            <Box display="flex" alignItems="center" width="100%">
                                                                                <Avatar
                                                                                    src={user.photo || ""}
                                                                                    style={{ width: 32, height: 32, marginRight: 12, fontSize: '0.9rem' }}
                                                                                >
                                                                                    {user.initials}
                                                                                </Avatar>
                                                                                <ListItemText primary={user.firstName} />
                                                                                {doc.firstName === user.firstName && <CheckIcon style={{ color: '#16a34a', fontSize: '1.2rem' }} />}
                                                                            </Box>
                                                                        </MenuItem>
                                                                    ))}
                                                                </div>
                                                            </Popover>
                                                        </div>
                                                    </Grid>
                                                )}
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="selectedDate"
                                                        variant="outlined"
                                                        label="Date"
                                                        name="selectedDate"
                                                        type="date"
                                                        error={formErrors.selectedDate && true}
                                                        value={addValues.selectedDate}
                                                        defaultValue="2017-05-24"
                                                        InputProps={{ inputProps: { max: ds } }}
                                                        onChange={handleChange}
                                                        className={formErrors.selectedDate && "input-error"}
                                                        // className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                    {formErrors.selectedDate && (
                                                        <span className="error">{formErrors.selectedDate}</span>
                                                    )}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="time"
                                                        label="Start-time"
                                                        variant="outlined"
                                                        type="time"
                                                        name="startTime"
                                                        error={formErrors.startTime && true}
                                                        value={addValues.startTime}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        inputProps={{
                                                            step: 300,
                                                        }}
                                                    />
                                                    {formErrors.startTime && (
                                                        <span className="error">{formErrors.startTime}</span>
                                                    )}
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="time"
                                                        label="End-time"
                                                        variant="outlined"
                                                        type="time"
                                                        name="endTime"
                                                        error={formErrors.endTime && true}
                                                        value={addValues.endTime}
                                                        onChange={handleChange}
                                                        className={classes.textField}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        inputProps={{
                                                            step: 300,
                                                        }}
                                                    />
                                                    {formErrors.endTime && (
                                                        <span className="error">{formErrors.endTime}</span>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={4} style={{ display: 'flex' }}>
                                                    <Button type="submit" style={{ marginTop: "10px", textTransform: 'capitalize' }} variant="contained" color="primary" disabled={submitLoading}>
                                                        {submitLoading ? <><CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Saving...</> : 'Save'}
                                                    </Button>
                                                    <Button type="button" style={{ marginTop: "10px", textTransform: 'capitalize' }} disabled={submitLoading} onClick={(e) => { e.preventDefault(); props.history.push('/time-entries') }}>Cancel</Button>
                                                </Grid>
                                                <Grid item xs={4}></Grid>
                                                <Grid item xs={4}></Grid>
                                            </Grid>
                                        </form>

                                        {tableLoading && (
                                            <Box display="flex" justifyContent="center" alignItems="center" mt={3} mb={1}>
                                                <CircularProgress size={28} />
                                            </Box>
                                        )}

                                        {dataFetched && !tableLoading && (
                                            notificationDetails.length > 0 ? (
                                                <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                                                    <Table>
                                                        <TableHead style={{ backgroundColor: "#1b6e95", color: "white" }}>
                                                            <TableRow>
                                                                <TableCell style={{ color: "white" }}>Employee ID</TableCell>
                                                                <TableCell style={{ color: "white" }}>Name</TableCell>
                                                                <TableCell style={{ color: "white" }}>Date</TableCell>
                                                                <TableCell style={{ color: "white" }}>Day</TableCell>
                                                                <TableCell style={{ color: "white" }}>In Time</TableCell>
                                                                <TableCell style={{ color: "white" }}>Out Time</TableCell>
                                                                <TableCell style={{ color: "white" }}>Duration</TableCell>
                                                                <TableCell style={{ color: "white" }}>Action</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {notificationDetails.map((detail, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell>{detail.emp_id}</TableCell>
                                                                    <TableCell>{detail.name}</TableCell>
                                                                    <TableCell>{detail.date}</TableCell>
                                                                    <TableCell>{moment(detail.date, 'DD-MM-YYYY').format('dddd')}</TableCell>
                                                                    <TableCell>{detail.in_time}</TableCell>
                                                                    <TableCell>{detail.out_time}</TableCell>
                                                                    <TableCell>{detail.duration}</TableCell>
                                                                    <Tooltip title="Add Time">
                                                                        <TableCell>
                                                                            <MdAddBox
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    color: hoveredButton === index ? "#000" : "#1b6e95",
                                                                                    transition: 'color 0.3s'
                                                                                }}
                                                                                onClick={() => handleClickOpen(detail)}
                                                                                size={26}
                                                                                onMouseEnter={() => handleMouseEnter(index)}
                                                                                onMouseLeave={handleMouseLeave}
                                                                            />
                                                                        </TableCell>
                                                                    </Tooltip>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            ) : (
                                                <TableRow style={{ display: "inline" }}>
                                                    <TableCell colSpan={8} align="center">
                                                        No missing entries for this day
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={6}></Grid>
                        </Grid>
                    </div>
                } />
            <Footer />
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>Add Time Entry</DialogTitle>
                <DialogContent>
                    {/* <DialogContentText>
                        Please fill in the details below to add a time entry.
                    </DialogContentText> */}
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="User Name"
                        type="text"
                        fullWidth
                        value={selectedDetail ? selectedDetail.name : ''}
                        disabled
                    />
                    <TextField
                        fullWidth
                        id="selectedDate"
                        label="Date"
                        name="selectedDate"
                        type="date"
                        error={formErrors.selectedDate && true}
                        value={addValues.selectedDate}
                        defaultValue="2017-05-24"
                        InputProps={{ inputProps: { max: ds } }}
                        onChange={handleChange}
                        className={formErrors.selectedDate && "input-error"}
                        // className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        margin="dense"
                        id="start-time"
                        label="Start-time"
                        type="time"
                        name="startTime"
                        fullWidth
                        value={addValues.startTime}
                        onChange={handlePopupChange}
                        error={formErrors.startTime && true}
                        helperText={formErrors.startTime}
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            step: 300,
                        }}
                    />
                    <TextField
                        margin="dense"
                        id="end-time"
                        label="End Time"
                        type="time"
                        name="endTime"
                        fullWidth
                        value={addValues.endTime}
                        onChange={handlePopupChange}
                        error={formErrors.endTime && true}
                        helperText={formErrors.endTime}
                        className={classes.textField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{
                            step: 300,
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAddTime} variant="contained" color="primary" disabled={submitLoading}>
                        {submitLoading ? <><CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Saving...</> : 'Add Time'}
                    </Button>
                    <Button onClick={handleClose} disabled={submitLoading}>
                        Cancel
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    )
}

export default AddTime;
